
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bPJJz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $61ea33d95bc1fe6f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $61ea33d95bc1fe6f$export$2e2bcd8739ae039 = {
    'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
    'ai-smart-button.ai-actions.actions.section.text': 'Acciones',
    'ai-smart-button.ai-actions.give-feedback-action.title': 'Enviar opiniones',
    'ai-smart-button.ai-actions.help.section.text': 'Ayuda',
    'ai-smart-button.ai-actions.input.link-picker-button-label': 'Enlace',
    'ai-smart-button.ai-actions.input.mention-button-label': "Menci\xf3n",
    'ai-smart-button.ai-actions.input.send-button-label': 'Enviar',
    'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
    'ai-smart-button.ai-actions.item.newLozenge': 'NOVEDAD',
    'ai-smart-button.ai-actions.rovo-agents.add-icon-label': "A\xf1adir icono",
    'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': "Icono de automatizaci\xf3n",
    'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatizaciones',
    'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Buscar agentes',
    'ai-smart-button.ai-actions.rovo-agents.create-automation.text': "Crear automatizaci\xf3n",
    'ai-smart-button.ai-actions.rovo-agents.section.text': 'Estudio',
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Hola, {name}:',
    'ai-smart-button.ai-proactive-nudge.dismiss': 'Descartar',
    'ai-smart-button.feedback-action.ask-question-option': 'Plantear una pregunta',
    'ai-smart-button.feedback-action.cancel-button-label': 'Cancelar',
    'ai-smart-button.feedback-action.choose-feedback-option': 'Elegir uno',
    'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Describe el error o la incidencia',
    'ai-smart-button.feedback-action.feedback-entry-comment-heading': "Cu\xe9ntanos qu\xe9 piensas",
    'ai-smart-button.feedback-action.feedback-entry-question-heading': "\xbfQu\xe9 te gustar\xeda saber?",
    'ai-smart-button.feedback-action.feedback-entry-suggest-heading': "Dinos qu\xe9 te gustar\xeda mejorar",
    'ai-smart-button.feedback-action.feedback-modal-heading': "Danos tu opini\xf3n",
    'ai-smart-button.feedback-action.leave-comment-option': 'Dejar un comentario',
    'ai-smart-button.feedback-action.report-bug-option': 'Informar de un error',
    'ai-smart-button.feedback-action.research-participation-message': "Me gustar\xeda participar en la investigaci\xf3n de productos",
    'ai-smart-button.feedback-action.select-feedback-heading': 'Seleccionar comentarios',
    'ai-smart-button.feedback-action.submit-button-label': 'Enviar comentarios',
    'ai-smart-button.feedback-action.suggest-improvement-option': 'Sugerir una mejora',
    'ai-smart-button.feedback-action.title': 'Enviar opiniones',
    'ai-smart-button.feedback-item.icon-label': 'Icono de feedback',
    'ai-smart-button.reference.close-button-label': 'Cerrar'
};

});


//# sourceMappingURL=es.f05f8cdd.js.map
